import {Component, Input, OnInit} from '@angular/core';
import {IGengineChatMessage} from "../i-gengine-chat-message";
import {GameSize} from "../../../game/game-size.service";

export class GengineAgingMessage {
  age = 0;
  constructor(public msg: IGengineChatMessage, public sent: boolean) {}
  pos = 0;
}

@Component({
  selector: 'app-message-line',
  templateUrl: './message-line.component.html',
  styleUrls: ['./message-line.component.css']
})
export class MessageLineComponent implements OnInit {
  @Input() msg: GengineAgingMessage;
  constructor(private gameSize: GameSize) { }

  ngOnInit(): void {
  }

  get size(): number {
    return this.gameSize.width / 50;
  }
  get bottom(): number {
    return this.gameSize.height / 4;
  }
  get style(): any {
    return {
      opacity: `${100 - 10*this.msg.age}%`,
      position: 'absolute',
      top: `${-this.bottom-this.msg.pos*this.size*1.5}px`,
      left:`${this.size}px`,
      width: `${this.gameSize.width-2*this.size}px`,
      'font-size': `${this.size}px`,
    }
  }
}
